import { FC } from 'react';
import styled, { css } from 'styled-components';
import getPalette, { Color, Variant } from 'utils/getPalette';
import Loader from './Loader';

type Props = {
  color?: Color;
  variant?: Variant;
  iconSide?: 'left' | 'right';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  icon?: React.ReactElement;
  loading?: boolean;
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;
const ButtonComponent: FC<Props> = ({
  color = 'default',
  variant = 'filled',
  iconSide = 'left',
  onClick,
  icon,
  children,
  loading,
  type,
  ...props
}) => {
  const palette = getPalette(variant, color);

  return (
    <button {...props} type={loading ? 'button' : type} onClick={onClick}>
      {iconSide === 'left' ? icon : null}
      {children}
      {loading && <Loader size={1} palette={palette} />}
      {iconSide === 'right' ? icon : null}
    </button>
  );
};

const Button = styled(ButtonComponent)`
  cursor: pointer;
  border-radius: 8px;
  padding: 0.5rem 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: var(--box-shadow);
  font-family: 'Inter', sans-serif;
  /* transition: ${({ loading }) => (loading ? '0' : '.2s')}; */
  position: relative;

  svg {
    height: 1rem;
    ${({ iconSide }) =>
      iconSide === 'right' ? 'margin-left' : 'margin-right'}: .55rem;
  }

  ${({ color, variant, loading }) => {
    const palette = getPalette(variant, color);
    return css`
      color: ${loading ? palette.bgColor : palette.color};
      stroke: ${palette.color};
      background-color: ${palette.bgColor};
      border: 1px solid ${palette.border};
      &:hover {
        color: ${loading ? palette.hover.bgColor : palette.hover.color};
        stroke: ${palette.hover.color};
        background-color: ${palette.hover.bgColor};
        border: 1px solid ${palette.hover.border};
      }
    `;
  }}

  .loader {
    position: absolute;
    top: calc(50% - 0.5rem);
    left: calc(50% - 0.5rem);
    /* transition: .2s; */
  }
  &:hover .loader {
    border-color: var(--hover-color);
    border-top-color: var(--hover-bg);
  }
  &:disabled {
    cursor: default;
    background-color: var(--gray-300);
    color: var(--gray-400);
    border-color: var(--gray-300);
  }
`;

export default Button;
